export default "__VITE_ASSET__BAdff2JK__"